import { render, staticRenderFns } from "./TypographyInput.vue?vue&type=template&id=5d7e4b4f&"
import script from "./TypographyInput.vue?vue&type=script&lang=ts&"
export * from "./TypographyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports